import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24">
    <path d="M15 3l2.12 2.12L10.24 12l6.88 6.88L15 21l-9-9 9-9z"/>
  </svg>
)
